/**
 * Rubicon Retail - Custom JS
 * Mobile menu population fix: bypasses touchstart gate so menu works
 * on all devices (touch, desktop-mobile, screen readers).
 */
(function() {
  'use strict';

  function populateMobileMenu() {
    // Only run on mobile widths
    if (window.innerWidth >= 1025) return;

    // Only run for custom menu mode
    if (window.mobile_menu !== 'custom') return;

    var navMobile = document.querySelector('[data-navigation-mobile]');
    var tabMobile = document.querySelector('[data-navigation-tab-mobile]');
    var menuSections = document.querySelectorAll('[data-section-type="menu"]');

    // Skip if already populated or elements missing
    if (!navMobile || !menuSections.length) return;
    if (navMobile.children.length > 0) return;

    var content = document.createElement('div');
    var tab = document.createElement('ul');
    tab.className = 'menu-tab list-unstyled';
    tab.setAttribute('role', 'menu');

    menuSections.forEach(function(element, index) {
      var tmpl = element.querySelector('template');
      if (!tmpl) return;
      var currentMenu = tmpl.content.firstElementChild.cloneNode(true);
      currentMenu.classList.add(index === 0 ? 'is-visible' : 'is-hidden');
      content.appendChild(currentMenu);
    });

    content.querySelectorAll('[id^="MenuMobileListSection-"]').forEach(function(element, index) {
      var tabTitle = element.dataset.heading;
      var tabId = element.getAttribute('id');
      var tabElement = document.createElement('li');
      tabElement.className = 'item';
      tabElement.setAttribute('role', 'menuitem');
      if (index === 0) tabElement.classList.add('is-active');
      tabElement.innerHTML = '<a class="link" href="#" data-mobile-menu-tab data-target="' + tabId + '">' + tabTitle + '</a>';
      tab.appendChild(tabElement);
    });

    if (tabMobile) tabMobile.innerHTML = '';
    if (tabMobile) tabMobile.appendChild(tab);
    navMobile.innerHTML = content.innerHTML;
  }

  // Run after DOM is ready and theme JS has initialized
  if (document.readyState === 'complete') {
    populateMobileMenu();
  } else {
    window.addEventListener('load', function() {
      // Small delay to ensure theme JS has run first
      setTimeout(populateMobileMenu, 100);
    });
  }

  // Also run on hamburger click as a safety net
  document.addEventListener('click', function(e) {
    if (e.target.closest && e.target.closest('.mobileMenu-toggle')) {
      populateMobileMenu();
    }
  });
})();
/* MOQ (Minimum Order Quantity) enforcement */
(function() {
  'use strict';

  function enforceQtyMOQ(input) {
    var moqMin = parseInt(input.getAttribute('min'), 10) || parseInt(input.dataset.moqMin, 10) || 1;
    var moqInc = parseInt(input.getAttribute('step'), 10) || parseInt(input.dataset.moqInc, 10) || 1;
    var val = parseInt(input.value, 10) || 0;

    if (val < moqMin) {
      input.value = moqMin;
    } else if (moqInc > 1) {
      var remainder = (val - moqMin) % moqInc;
      if (remainder !== 0) {
        input.value = val - remainder + moqInc;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Enforce on input change (every keystroke/paste)
    document.addEventListener('input', function(e) {
      if (e.target.matches && e.target.matches('input.quantity__input[data-moq-min]')) {
        enforceQtyMOQ(e.target);
      }
    });

    // Enforce on form submit (catch any race conditions)
    document.addEventListener('submit', function(e) {
      var form = e.target;
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      var moqMin = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      var moqInc = parseInt(qtyInput.getAttribute('step'), 10) || 1;
      var val = parseInt(qtyInput.value, 10) || 0;

      if (val < moqMin) {
        qtyInput.value = moqMin;
      } else if (moqInc > 1) {
        var remainder = (val - moqMin) % moqInc;
        if (remainder !== 0) {
          qtyInput.value = val - remainder + moqInc;
        }
      }
    });
  });
})();

/* ============================================================
   2026-09-07 — Price range filter
   Two measured defects on collection pages:
     1. The track's --left-space / --right-space initialised to "NaNpx"
        (they are derived from the number inputs, which start empty), so the
        ::before/::after fills collapsed and no range was indicated.
     2. Pressing Enter in the min/max boxes did nothing — only the Apply
        button submitted, which is not discoverable.
   Runs on load and re-binds after the AJAX facet re-render.
   ============================================================ */
(function () {
  'use strict';

  function num(v, fallback) {
    var n = parseFloat(v);
    return isFinite(n) ? n : fallback;
  }

  function syncSlider(slide) {
    var min = slide.querySelector('.filter__price_min');
    var max = slide.querySelector('.filter__price_max');
    if (!min || !max) return;

    var floor = num(min.min, 0);
    var ceil = num(min.max, 0);
    if (ceil <= floor) return;

    var lo = num(min.value, floor);
    var hi = num(max.value, ceil);
    if (lo > hi) { var t = lo; lo = hi; hi = t; }

    var width = slide.getBoundingClientRect().width;
    if (!width) return;

    var leftPx = ((lo - floor) / (ceil - floor)) * width;
    var rightPx = ((ceil - hi) / (ceil - floor)) * width;

    // These were the NaN values. Kept so the theme's own ::before/::after
    // greyed-out ends work as designed.
    slide.style.setProperty('--left-space', Math.max(0, Math.round(leftPx)) + 'px');
    slide.style.setProperty('--right-space', Math.max(0, Math.round(rightPx)) + 'px');

    var fill = slide.querySelector('.filter__price_range-fill');
    if (!fill) {
      fill = document.createElement('span');
      fill.className = 'filter__price_range-fill';
      slide.appendChild(fill);
    }
    fill.style.left = Math.max(0, Math.round(leftPx)) + 'px';
    fill.style.width = Math.max(0, Math.round(width - leftPx - rightPx)) + 'px';
  }

  function syncAll() {
    document.querySelectorAll('.facets__price--slide').forEach(syncSlider);
  }

  // Keep the two handles from crossing, mirror them into the number boxes.
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('filter__price_change')) return;
    var slide = el.closest('.facets__price--slide');
    if (!slide) return;

    var min = slide.querySelector('.filter__price_min');
    var max = slide.querySelector('.filter__price_max');
    if (min && max && num(min.value, 0) > num(max.value, 0)) {
      if (el === min) { min.value = max.value; } else { max.value = min.value; }
    }

    var box = slide.closest('.facets__price--slider') || slide.parentElement;
    var boxes = box ? box.querySelectorAll('.filter__price[type="number"]') : [];
    if (boxes.length === 2 && min && max) {
      boxes[0].value = Math.round(num(min.value, 0));
      boxes[1].value = Math.round(num(max.value, 0));
    }
    syncSlider(slide);
  });

  // Typing a value should move the handles too.
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('filter__price')) return;
    if (el.type !== 'number') return;
    var wrap = el.closest('.facets__price--slider');
    var slide = wrap ? wrap.querySelector('.facets__price--slide') : null;
    if (!slide) return;
    var boxes = wrap.querySelectorAll('.filter__price[type="number"]');
    var min = slide.querySelector('.filter__price_min');
    var max = slide.querySelector('.filter__price_max');
    if (boxes.length === 2 && min && max) {
      if (boxes[0].value !== '') min.value = boxes[0].value;
      if (boxes[1].value !== '') max.value = boxes[1].value;
      syncSlider(slide);
    }
  });

  // Enter in either price box applies the filter, like the button.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target;
    if (!el.classList || !el.classList.contains('filter__price')) return;
    if (el.type !== 'number') return;
    var wrap = el.closest('.facets__price--slider') || el.closest('.facets__price');
    var apply = wrap ? wrap.querySelector('.filter__price--apply') : null;
    if (apply) {
      e.preventDefault();
      apply.click();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  window.addEventListener('load', function () { syncAll(); setTimeout(syncAll, 400); });
  window.addEventListener('resize', syncAll);

  // Facets re-render over AJAX; re-sync when the sidebar subtree changes.
  var host = document.querySelector('.halo-collection-content') || document.body;
  if (window.MutationObserver && host) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(syncAll, 120);
    }).observe(host, { childList: true, subtree: true });
  }
})();

/* Dual-range hit-testing: the two overlapping inputs both span the full track,
   so without help the top one swallows every press and the other handle can
   never be grabbed. Raise whichever handle is nearer the pointer. */
(function () {
  'use strict';
  function nearest(e) {
    var slide = e.target.closest ? e.target.closest('.facets__price--slide') : null;
    if (!slide) return;
    var min = slide.querySelector('.filter__price_min');
    var max = slide.querySelector('.filter__price_max');
    if (!min || !max) return;
    var r = slide.getBoundingClientRect();
    if (!r.width) return;
    var lo = parseFloat(min.min) || 0;
    var hi = parseFloat(min.max) || 0;
    if (hi <= lo) return;
    var pct = (e.clientX - r.left) / r.width;
    var val = lo + pct * (hi - lo);
    var dMin = Math.abs(val - (parseFloat(min.value) || 0));
    var dMax = Math.abs(val - (parseFloat(max.value) || 0));
    min.style.zIndex = dMin <= dMax ? '4' : '3';
    max.style.zIndex = dMin <= dMax ? '3' : '4';
  }
  document.addEventListener('pointermove', nearest, { passive: true });
  document.addEventListener('pointerdown', nearest, { passive: true });
})();

/* ---------------------------------------------------------------
   Sticky header: restore the identity bar when back at the page top.

   Defect (pre-existing; present on the live theme too, logged as D18):
   scrolling down adds `shopify-section-header-hidden` AND
   `shopify-section-header-sticky` to the header section, and the theme hides
   .header-top. Scrolling back to the very top removes `-hidden` but leaves
   `-sticky`, so .header-top stays `display:none` forever — the logo, the
   Customer Service number, Shopping Cart and Sign In never come back, and the
   wrapper keeps reserving their height, leaving a gap.

   Rather than change the sticky component's behaviour (its compaction while
   scrolled is intentional), mark the "genuinely at the top" state and let CSS
   restore the bar only there. No layout shift: the wrapper already reserves
   the full height.
   --------------------------------------------------------------- */
(function () {
  var root = document.documentElement;
  var atTop = null;
  function sync() {
    var now = (window.scrollY || window.pageYOffset || 0) <= 2;
    if (now === atTop) { return; }   // only touch the DOM on a real change
    atTop = now;
    root.classList.toggle('rb-at-page-top', now);
  }
  sync();
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync, { passive: true });
})();
